import {Accordion, AccordionItem} from "@nextui-org/react";
import {useState} from "react";
// export const NeoAGHeader: React.FC<NeoTableHeaderProps> = ({

export const SidebarDrawer: React.FC<any> = ({
  columns,
  setActiveColumns,
  activeColumns,
  items,
  activePanel,
  setActivePanel
  //setSearchFilterText
}) => {
  const [columnFilterValue, setColumnFilterValue] = useState([]);
  const handleToggle = (uid: string) => {
    setActiveColumns(
      (prev: any) =>
        prev.includes(uid)
          ? prev.filter((id: any) => id !== uid) // remove if already selected
          : [...prev, uid] // add if not selected
    );
  };

  const handleColumnData = (uid: string) => {
    const uniqueValues = items.reduce((acc: any[], item: any) => {
      const val = item[uid];
      // skip null/undefined if you like:
      if (val != null && !acc.includes(val)) {
        acc.push(val);
      }
      return acc;
    }, []);
    setColumnFilterValue(uniqueValues);
  };

  const handleSearchFilterval = (val: string) => {
    //setSearchFilterText(val);
  };
  return (
    <div className="flex h-[80vh]">
      {/* Drawer */}
      {activePanel && (
        <div className="w-full rounded-r-md bg-blue-100 p-4 shadow-md">
          {activePanel === "columns" && (
            <div>
              <div className="mb-2 font-semibold">View Columns</div>
              {/* <input type="checkbox" checked /> Show All */}
              {/* <input
                type="text"
                placeholder="Search..."
                className="mb-4 w-full rounded border p-1"
              /> */}
              <div className="max-h-[60vh] overflow-y-auto px-2 ">
                {columns.map((item: {uid: string; name: string}) => (
                  //   <label key={item} className="flex items-center gap-2">
                  //     <input type="checkbox" checked />
                  //     <span>{item}</span>
                  //   </label>
                  <div
                    className="max-h-40 space-y-1 overflow-y-auto px-1"
                    key={item.uid}
                  >
                    <li
                      className="flex list-none  gap-2 rounded border border-gray-200 px-1 py-1"
                      key={item.uid}
                    >
                      <input
                        type="checkbox"
                        onChange={() => handleToggle(item.uid)}
                        checked={activeColumns.includes(item.uid)}
                        className="form-checkbox text-blue-500"
                      />
                      {/* <svg
                        className="mx-2 h-4 w-4 cursor-move text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M7 4h2v2H7V4zm4 0h2v2h-2V4zM7 8h2v2H7V8zm4 0h2v2h-2V8zM7 12h2v2H7v-2zm4 0h2v2h-2v-2z" />
                      </svg> */}
                      <span className="text-xs text-gray-700">{item.name}</span>
                    </li>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activePanel === "filters" && (
            <div>
              <div className="text-lg font-semibold">Filters</div>
              <div className="max-h-[60vh] overflow-y-auto px-2 ">
                <Accordion isCompact variant="splitted">
                  {columns.map((item: {uid: string; name: string}) => (
                    <AccordionItem
                      key={item.uid}
                      title={<span className="text-sm">{item.name}</span>}
                      classNames={{content: "text-sm"}}
                      onPress={() => {
                        handleColumnData(item.uid);
                      }}
                    >
                      {columnFilterValue.map((val: string) => (
                        <li
                          className="flex list-none  gap-2 rounded border border-gray-200 px-1 py-1"
                          key={item.uid}
                        >
                          <input
                            type="checkbox"
                            onChange={() => handleSearchFilterval(val)}
                            //checked={activeColumns.includes(val)}
                            className="form-checkbox text-blue-500"
                          />
                          {/* <svg
                              className="mx-2 h-4 w-4 cursor-move text-gray-400"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M7 4h2v2H7V4zm4 0h2v2h-2V4zM7 8h2v2H7V8zm4 0h2v2h-2V8zM7 12h2v2H7v-2zm4 0h2v2h-2v-2z" />
                            </svg> */}
                          <span className="text-xs text-gray-700">{val}</span>
                        </li>
                      ))}
                    </AccordionItem>
                  ))}
                </Accordion>
                {/* <div>
                  <div className="mb-2 flex items-center justify-between font-medium">
                    <span>Athlete</span>
                    <span className="text-sm text-gray-500">🔽</span>
                  </div>
                </div> */}

                {/* Collapsible Filter Categories (Year, Date, etc.) */}
                {/* {Object.keys(filters)
                  .filter(key => key !== "Athlete")
                  .map(key => (
                    <details key={key} className="text-sm">
                      <summary className="cursor-pointer py-1 font-medium">
                        {key}
                      </summary>
                    </details>
                  ))} */}
              </div>
            </div>
          )}
        </div>
      )}
      {/* Sidebar */}
      {/* <div className="flex w-12 flex-col overflow-hidden rounded-r-md bg-blue-100">
        <div className="mt-3 flex flex-col items-center gap-2"> */}
      {/* <button
            onClick={() =>
              setActivePanel(activePanel === "columns" ? null : "columns")
            }
            className="group relative flex h-24 w-full items-center justify-center hover:bg-blue-200"
          >
            <div
              className={`absolute bottom-0 left-0 top-0 w-1 ${
                activePanel === "columns" ? "bg-orange-400" : "bg-transparent"
              }`}
            ></div>
            <div className="rotate-[90deg] transform text-sm font-bold text-black">
              <span className="inline-flex items-center">
                <svg
                  className="mr-1 h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                  />
                </svg>
                Columns
              </span>
            </div>
          </button> */}

      {/* <button
            onClick={() =>
              setActivePanel(activePanel === "filters" ? null : "filters")
            }
            className="group relative flex h-24 w-full items-center justify-center hover:bg-blue-200"
          >
            <div
              className={`absolute bottom-0 left-0 top-0 w-1 ${
                activePanel === "filters" ? "bg-orange-400" : "bg-transparent"
              }`}
            ></div>
            <div className="rotate-[90deg] transform text-sm font-bold text-black">
              <span className="inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="22 3 2 3 10 13 10 19 14 21 14 13 22 3"></polygon>
                </svg>
                Filters
              </span>
            </div>
          </button> */}
    </div>
    //   </div>
    // </div>
  );
};
